import { constants } from '../constant/constants';
import { HttpHelper } from '../helper/http-helper-service';

export default class ClientService {
    static getAllClientLocations = (_param: any = null) => {
        return HttpHelper.getData(constants.apiUrl.crmUrls.alllocations, {});
    }

    static getClientLocations(clientId: number) {
        return HttpHelper.getData(
            constants.apiUrl.crmUrls.getClientLocation.replace(
                /{id}/gi,
                clientId + ""
            ),
            {}
        );
    }

    static getClientDetailById = (clientId: number) => {
        return HttpHelper.getData(
            constants.apiUrl.crmUrls.getClientDetailById + `/${clientId}`
        );
    }

    static getClients = (_params: any = null) => {
        return HttpHelper.getData(constants.apiUrl.crmUrls.getClientList);
    }

    static async getClientByTick(tick: number) {
        return HttpHelper.getData(constants.apiUrl.crmUrls.getClientByTick + "?storeTick=" + tick);
    }
}
